<div #confirmPortal>
  @if (visible()) {
  <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-xs z-[9999] flex items-center justify-center p-4 confirm-overlay"
    (click)="requireReason() ? null : cancel()">
    <div #panel role="alertdialog" aria-modal="true" tabindex="-1" [attr.aria-labelledby]="titleId" [attr.aria-describedby]="descId"
      class="relative outline-none bg-white border border-slate-200/90 rounded-3xl pt-14 pb-7 px-8 max-w-[420px] w-full text-center shadow-2xl flex flex-col items-center mt-8 confirm-card"
      (click)="$event.stopPropagation()">

      <!-- Icono flotante superior -->
      <div class="absolute -top-10 w-20 h-20 rounded-full flex items-center justify-center shadow-xl ring-8 ring-white"
        [ngClass]="getIconColorClass()">
        <i aria-hidden="true" [class]="icon()" style="font-size: 1.75rem !important;"></i>
      </div>

      <!-- Título principal -->
      <h3 [id]="titleId" class="text-base font-extrabold text-slate-900 uppercase tracking-wider mt-2">
        {{ title() }}
      </h3>

      <!-- Descripción enriquecida -->
      <p [id]="descId" class="text-xs text-slate-500 mt-3 leading-relaxed px-2 font-normal">
        {{ description() }}
      </p>

      @if (requireReason()) {
        <div class="w-full mt-4 text-left">
          <label [for]="reasonId" class="block mb-1.5 text-xs font-semibold text-slate-500">{{ reasonLabel() }} <span class="text-danger-500">*</span></label>
          <textarea
            [id]="reasonId"
            rows="3"
            [attr.maxlength]="reasonMax()"
            [value]="reason()"
            (input)="reason.set($any($event.target).value); reasonTouched.set(true)"
            (blur)="reasonTouched.set(true)"
            [placeholder]="reasonPlaceholder()"
            [attr.aria-invalid]="reasonError() ? true : null"
            [attr.aria-describedby]="reasonError() ? reasonId + '-err' : null"
            data-testid="confirm-reason"
            class="block w-full px-3.5 py-2.5 rounded-xl bg-slate-50 border text-sm text-slate-900 focus:outline-none focus:ring-2 transition-all resize-none"
            [ngClass]="reasonError() ? 'border-danger-500 focus:border-danger-500 focus:ring-danger-500/10' : 'border-slate-200 focus:border-primary-500 focus:ring-primary-500/10'"
          ></textarea>
          <div class="flex items-start justify-between gap-3 mt-1">
            @if (reasonError()) {
              <small [id]="reasonId + '-err'" role="alert" class="text-danger-600 text-xs pl-2 font-medium">{{ reasonError() }}</small>
            } @else {
              <span class="text-2xs text-slate-500 pl-2">Mínimo {{ reasonMin() }} caracteres</span>
            }
            <span class="shrink-0 text-2xs text-slate-500">{{ reasonLength() }}/{{ reasonMax() }}</span>
          </div>
        </div>
      }

      <!-- Botones de Acción en una sola línea -->
      <div class="flex gap-3 w-full mt-7">
        <button
          type="button"
          data-autofocus
          (click)="cancel()"
          [disabled]="loading()"
          class="flex-1 py-2.5 px-4 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-xs uppercase tracking-wider transition-all cursor-pointer flex items-center justify-center gap-1.5 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
          <i class="pi pi-times text-xs"></i>
          <span>{{ cancelLabel() }}</span>
        </button>
        <button
          type="button"
          (click)="confirm()"
          [disabled]="loading() || !reasonValid()"
          [ngClass]="getConfirmButtonClass()"
          class="flex-1 py-2.5 px-4 rounded-xl font-bold text-xs uppercase tracking-wider transition-all cursor-pointer flex items-center justify-center gap-1.5 whitespace-nowrap border-0 shadow-sm disabled:opacity-70 disabled:cursor-not-allowed">
          @if (loading()) {
            <i class="pi pi-spin pi-spinner text-xs"></i>
          } @else {
            <i class="pi pi-check text-xs"></i>
          }
          <span>{{ confirmLabel() }}</span>
        </button>
      </div>

    </div>
  </div>
  }
</div>